// src/pages/academy/components/AcademyFormFields.jsx
import { useRef } from "react";
import { Upload, X, ImageIcon } from "lucide-react";

/**
 * حقل الأيقونة.
 *  - serverIcon: الأيقونة الحالية من الباك إند (وقت التعديل)
 *  - newPreview: preview للملف اللي لسه مختاره المستخدم
 *  - "×" بتلغي الملف الجديد بس وترجع للأيقونة الحالية
 *    (الـ icon في الـ serializers write_only، فمفيش مسح من هنا)
 */
export function IconField({ serverIcon, newPreview, onPick, onClear }) {
  const inputRef = useRef(null);
  const preview = newPreview || serverIcon;

  return (
    <div className="space-y-1.5">
      <label className="block text-sm font-medium text-gray-700 text-right">
        الأيقونة
      </label>
      <div className="flex items-center gap-4">
        {preview ? (
          <div className="relative w-16 h-16 rounded-xl overflow-hidden border border-gray-200 flex-shrink-0">
            <img
              src={preview}
              alt="icon preview"
              className="w-full h-full object-cover"
            />
            {newPreview && (
              <button
                type="button"
                onClick={() => {
                  onClear();
                  if (inputRef.current) inputRef.current.value = "";
                }}
                className="absolute top-0.5 right-0.5 bg-red-500 text-white rounded-full p-0.5"
                aria-label="Discard new icon"
              >
                <X className="w-3 h-3" />
              </button>
            )}
          </div>
        ) : (
          <div className="w-16 h-16 rounded-xl border-2 border-dashed border-gray-300 flex items-center justify-center flex-shrink-0">
            <ImageIcon className="w-6 h-6 text-gray-400" />
          </div>
        )}

        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-xl text-sm text-gray-700 hover:bg-gray-50"
        >
          <Upload className="w-4 h-4" />
          {preview ? "تغيير الأيقونة" : "رفع أيقونة"}
        </button>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onPick(file);
          }}
          className="hidden"
        />
      </div>
    </div>
  );
}

export function ActiveToggle({ value, onChange }) {
  return (
    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
      <span className="text-sm font-medium text-gray-700">نشط</span>
      <button
        type="button"
        role="switch"
        aria-checked={value}
        onClick={() => onChange(!value)}
        dir="ltr"
        className={`relative w-12 h-6 rounded-full transition-colors ${
          value ? "bg-indigo-500" : "bg-gray-300"
        }`}
      >
        <span
          className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform ${
            value ? "translate-x-7" : "translate-x-1"
          }`}
        />
      </button>
    </div>
  );
}

export const inputClass =
  "w-full px-4 py-2.5 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 text-right";

export function Field({ label, required, children }) {
  return (
    <div className="space-y-1.5">
      <label className="block text-sm font-medium text-gray-700 text-right">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
    </div>
  );
}